import React, { useState, useEffect } from 'react';
import { boardsAPI } from '../api/api';
import './Modal.css';

interface EditColumnModalProps {
  boardId: number;
  columnId: number;
  currentName: string;
  onClose: () => void;
  onColumnUpdated: () => void;
}

const EditColumnModal: React.FC<EditColumnModalProps> = ({ 
  boardId, 
  columnId, 
  currentName, 
  onClose, 
  onColumnUpdated 
}) => {
  const [name, setName] = useState(currentName);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    setName(currentName);
  }, [currentName]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim()) {
      setError('Название столбца обязательно');
      return;
    }

    if (name.trim() === currentName) {
      onClose();
      return;
    }

    setLoading(true);
    setError('');

    try {
      await boardsAPI.updateColumn(boardId, columnId, { name: name.trim() });
      onColumnUpdated();
      onClose();
    } catch (err: any) {
      setError(err.response?.data?.error || 'Ошибка при обновлении столбца');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Переименовать столбец</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Название столбца *</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              placeholder="Например: В работе"
              autoFocus
            />
          </div>
          {error && <div className="error">{error}</div>}
          <div className="modal-actions">
            <button type="submit" className="submit-btn" disabled={loading}>
              {loading ? 'Сохранение...' : 'Сохранить'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditColumnModal;
